import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ConfirmationDialogService } from '../services/confirmation-dialog';
import { RippleDirective } from '../directives/ripple';

@Component({
  selector: 'lib-ui-confirmation-dialog',
  imports: [CommonModule, RippleDirective],
  template: `
    @if (dialogService.isVisible()) {
      <div
        class="fixed inset-0 bg-black/40 z-50 flex items-center justify-center"
      >
        <div
          class="bg-white dark:bg-background-dark p-6 rounded shadow-xl w-[90%] max-w-md"
        >
          <h2 class="text-lg font-bold mb-2">
            {{ dialogService.dialogOptions()?.title ?? 'Confirm' }}
          </h2>
          <p class="mb-4 text-gray-700 dark:text-gray-300">
            {{ dialogService.dialogOptions()?.message ?? '' }}
          </p>
          <div class="flex justify-end gap-2">
            <button
              libUiRipple
              type="button"
              class="px-3 py-1.5 text-xs text-white bg-gray-600 rounded cursor-pointer"
              (click)="dialogService.reject()"
            >
              Cancel
            </button>
            <button
              libUiRipple
              type="button"
              class="px-3 py-1.5 text-xs text-white rounded cursor-pointer"
              [class.bg-blue-600]="
                dialogService.dialogOptions()?.type === 'info'
              "
              [class.bg-red-600]="
                dialogService.dialogOptions()?.type === 'danger'
              "
              (click)="dialogService.accept()"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmationDialog {
  dialogService = inject(ConfirmationDialogService);
}
